interface aButtonOptions {
  buttonArrowSelector?: string;
}

export const aButton = (options?: aButtonOptions) => {
  /**
   * When a paragraph only contains buttons, we need to apply styles to that paragraph
   */
  const handleParagraphs = () => {
    const paragraphs: HTMLParagraphElement[] = Array.from(
      document.querySelectorAll('p')
    );
    paragraphs.forEach((paragraph) => {
      const children = Array.from(paragraph.children);

      if (children.length > 1) {
        if (children.find((x) => x.classList.contains('button'))) {
          // Remove unnessessary non breaking spaces that Craft creates when the user hits the spacebar too often
          paragraph.innerHTML = paragraph.innerHTML.replace(/&nbsp;/g, '');
        }
      }
    });
  };

  /**
   * Trigger primary button hover radial gradient via cursor
   */
  const handleButtonPrimaryHover = () => {
    /** @type {NodeListOf<HTMLElement>} Buttons */
    const buttons: (HTMLButtonElement | HTMLAnchorElement | HTMLSpanElement)[] =
      Array.from(
        document.querySelectorAll(
          '.button--primary, .button--secondary, .button--has-icon'
        )
      );

    const onMouseMove = (e: MouseEvent) => {
      const el = <HTMLElement>e.target;
      const rect = el.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      el.style.setProperty('--x', x + 'px');
      el.style.setProperty('--y', y + 'px');
    };

    buttons.forEach((element) => {
      if (
        element.textContent &&
        element.classList.contains('button--has-icon')
      ) {
        element.innerHTML =
          "<span class='button-icon'>" + element.innerHTML + '</span>';
      } else if (element.textContent) {
        element.innerHTML = '<span>' + element.textContent + '</span>';
      } else {
        element.innerHTML = '<span>' + element.innerHTML + '</span>';
      }

      element.classList.add('is-hoverable');

      element.addEventListener('mousemove', onMouseMove);
    });
  };

  const handleButtonArrow = () => {
    const arrowIcon = `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none"><path fill="currentColor" fill-rule="evenodd" d="m14.357 12-4.224-4.224a.455.455 0 0 1 .643-.643l4.332 4.332a.757.757 0 0 1-.001 1.071l-4.331 4.33a.455.455 0 0 1-.643-.642L14.357 12Z" clip-rule="evenodd"/></svg>
    `;

    const buttons: (HTMLButtonElement | HTMLAnchorElement)[] = Array.from(
      document.querySelectorAll(
        options && options.buttonArrowSelector
          ? options.buttonArrowSelector
          : '.button--arrow'
      )
    );

    buttons.forEach((button) => {
      const iconWrapper = document.createElement('span');
      iconWrapper.classList.add('iconWrapper');
      iconWrapper.innerHTML = arrowIcon;
      iconWrapper.setAttribute('aria-hidden', 'true');
      button.append(iconWrapper);
    });
  };

  handleParagraphs();
  handleButtonPrimaryHover();
  handleButtonArrow();
};
